module.exports = __webpack_public_path__ + "img/logo_final.2187a759.png";